import { useEditor } from '../store';

/**
 * The two history buttons.
 *
 * Round, because Sascha asked for circles -- and because a circle is the shape
 * a thumb aims at. The arrows are drawn rather than typed: the glyphs ↶ and ↷
 * come out of whatever font the phone happens to pick, hairline-thin on iOS
 * and a different weight than the rest of the bar.
 *
 * Each button says what it will take back ("Rückgängig: Clip verschoben"), so
 * the arrow is not the only thing to go on before pressing it.
 */
/**
 * Three quarters of a circle with the head at the top, pointing back the way
 * it came -- the ↺ everyone knows. The first attempt was the other common
 * shape, a straight tail with a hook on the end; on the phone that reads as a
 * shower head, which is what Sascha saw.
 *
 * Circle: centre 12,12, radius 7. The arc runs from the left point (5,12)
 * anticlockwise round the bottom and the right side up to the top (12,5), so
 * the open quarter sits top left and the head has somewhere to point.
 */
const ARC = 'M5 12A7 7 0 1 0 12 5';
const HEAD = '14.6 2.6 12 5 14.6 7.4';

export function UndoRedo() {
  const undo = useEditor((s) => s.undo);
  const redo = useEditor((s) => s.redo);
  const undoEntry = useEditor((s) => s.undoStack.at(-1));
  const redoEntry = useEditor((s) => s.redoStack.at(-1));

  return (
    <div className="history">
      <button
        type="button"
        className="round-btn"
        onClick={undo}
        disabled={!undoEntry}
        title={undoEntry ? `Rückgängig: ${undoEntry.label}` : 'Nichts rückgängig zu machen'}
        aria-label={undoEntry ? `Rückgängig: ${undoEntry.label}` : 'Rückgängig'}
        data-undo
      >
        <Arrow direction="back" />
      </button>
      <button
        type="button"
        className="round-btn"
        onClick={redo}
        disabled={!redoEntry}
        title={redoEntry ? `Wiederherstellen: ${redoEntry.label}` : 'Nichts wiederherzustellen'}
        aria-label={redoEntry ? `Wiederherstellen: ${redoEntry.label}` : 'Wiederherstellen'}
        data-redo
      >
        <Arrow direction="forward" />
      </button>
    </div>
  );
}

/** One arrow, mirrored for the way back. `currentColor` so the disabled state
 *  needs no second icon. */
function Arrow({ direction }: { direction: 'back' | 'forward' }) {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform={direction === 'back' ? undefined : 'translate(24 0) scale(-1 1)'}
      >
        <path d={ARC} />
        <polyline points={HEAD} />
      </g>
    </svg>
  );
}
